'use client';

import React from 'react';
import ContactMethods from './ContactMethods';
import QuickContactForm from './QuickContactForm';
import OfficeLocations from './OfficeLocations';
import FAQSection from './FAQSection';

const ContactInteractive = () => {
  return (
    <>
      <ContactMethods />
      <QuickContactForm />
      <OfficeLocations />
      <FAQSection />
    </>
  );
};

export default ContactInteractive;